import { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from "@mui/material/Typography";

const MpgSuccessDialog = ({ title, content, open, extraLogicHandlerOnOK, sx }) => {

    const [openDialog, setOpenDialog] = useState(false)

    useEffect(() => {
        if (!!open) {
            setOpenDialog(true)
        } else {
            setOpenDialog(false)
        }
    }, [open])

    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick") {
            return '';
        } else {
            setOpenDialog(false);
        }
    };

    const callExtraLogicHandlerOnOK = () => {
        if (!!extraLogicHandlerOnOK) {
            extraLogicHandlerOnOK()
        }
        handleClose()
    }

    let dialogContent = ""
    if (content?.includes("\n")) {
        dialogContent = content.split('\n').map(str => <p>{str}</p>);
    } else {
        dialogContent = content
    }

    const internalSx = {
        zIndex: 1500
    }
    return (
        <div>
            <Dialog
                open={openDialog}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={[internalSx, sx]}
            >
                <DialogTitle id="alert-dialog-title" sx={{ color: 'green', fontWeight: 'bold' }}>
                    {
                        !!title ? title : `Successfully done...!`
                    }
                </DialogTitle>
                <DialogContent>
                    <Typography
                        variant="body2"
                        align="center"
                    >
                        {
                            !!dialogContent ? dialogContent : `The action is performed successfully.`
                        }
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        callExtraLogicHandlerOnOK()
                    }}
                        autoFocus
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
export default MpgSuccessDialog